import React from 'react';
import { useTranslations } from 'next-intl';

import classes from './ToggleSwitch.module.scss';

export const ToggleSwitch: React.FC<{
  className?: string;
  checkedLabel?: string;
  unCheckedLabel?: string;
  checked?: boolean;
  ariaLabel?: string;
  onChange?: (v: boolean) => void,
}> = ({
  className,
  checked,
  checkedLabel,
  unCheckedLabel,
  ariaLabel,
  onChange = (v) => { },
}) => {
  const t = useTranslations();
  
  const defaultCheckedLabel = checkedLabel ?? t('toggleSwitch.checked');
  const defaultUnCheckedLabel = unCheckedLabel ?? t('toggleSwitch.unchecked');
  const defaultAriaLabel = ariaLabel ?? t('toggleSwitch.ariaLabel');

    return (
      <div className={[className, classes.wrapper].filter(Boolean).join(' ')}>
        <div>
          {defaultUnCheckedLabel}
        </div>
        <label className={classes.switch}>
          <input
            className={classes.switch__input}
            type="checkbox"
            role="switch"
            checked={checked}
            onChange={() => onChange(!checked)}
          />
          <span className={classes.switch__label}>{defaultAriaLabel}</span>
        </label>
        <div>
          {defaultCheckedLabel}
        </div>
      </div>
    );
  };

export default ToggleSwitch;
